export const MUTATION_UPDATE_CONTRIBUTION = /* GraphQL */ `
  mutation updateOnlineContributionConfiguration(
    $input: UpdateOnlineContributionConfigurationInput!
  ) {
    updateOnlineContributionConfiguration(input: $input) {
      onlineContributionConfiguration {
        id
        active
        name
        sellerId
        publicOnlineDonationUrl
        documentType
        documentNumber
        boletoFixedCharge
        statusGateway
        bankAccount {
          bankAccountType
          agency
          number
          bank {
            id
            code
          }
        }
        gatewayPlans {
          collection {
            name
            active
          }
        }
      }
    }
  }
`

export const MUTATION_CREATE_ACCOUNT = /* GraphQL */ `
  mutation createOnlineContributionConfiguration(
    $input: OnlineContributionConfigurationInput!
  ) {
    createOnlineContributionConfiguration(input: $input) {
      onlineContributionConfiguration {
        id
        active
        name
        sellerId
        publicOnlineDonationUrl
        documentType
        documentNumber
        boletoFixedCharge
        statusGateway
        bankAccount {
          bankAccountType
          agency
          number
          bank {
            id
            code
          }
        }
        gatewayPlans {
          collection {
            name
            active
          }
        }
      }

      errors {
        attribute
        message
      }
    }
  }
`
export const MUTATION_CHANGE_GATEWAY_PLAN = /* GraphQL */ `
  mutation changeGatewayPlan($input: GatewayPlanInputTypes!) {
    changeGatewayPlan(input: $input) {
      errors {
        attribute
        message
      }
      gatewayPlan {
        name
        active
        onlineContributionConfiguration {
          sellerId
        }
      }
    }
  }
`
